import { Injectable } from '@angular/core';
import { HttpStrategyResolver } from '@nimbus-library/features/shared/services/base-http/http-stratagy.resolver';
import { RequestAggregatorApiClient } from '../request-aggregator.api-client';
import { AggregatedHttpStrategy } from './aggregated-http.strategy';
import { AggregatedRequestScope } from './aggregated-request.scope';

@Injectable({ providedIn: 'root' })
export class RequestAggregatorService {
  public constructor(
    private readonly httpStratgeyResolver: HttpStrategyResolver,
    private readonly aggregatedHttpStrategy: AggregatedHttpStrategy,
    private readonly requestAggregatorApiClient: RequestAggregatorApiClient,
  ) {}

  public isAggregating(): boolean {
    return this.aggregatedHttpStrategy.hasOpenScope();
  }

  public aggregatedRequest<TResult>(createObservables$: () => TResult): TResult {
    this.aggregatedHttpStrategy.beginScope();
    this.httpStratgeyResolver.setStrategy(this.aggregatedHttpStrategy);

    let result: TResult;
    let scope: AggregatedRequestScope;

    try {
      result = createObservables$();
    } finally {
      this.httpStratgeyResolver.setDefaultStrategy();
      scope = this.aggregatedHttpStrategy.endScope();
    }

    scope.execute((requests) => this.requestAggregatorApiClient.request(requests));

    return result;
  }
}
